export default {
  "gemGoodsAdmin.thead.index": "#NO",
  "gemGoodsAdmin.thead.documentId": "DocumentId",
  "gemGoodsAdmin.thead.goodsId": "GoodsId",
  "gemGoodsAdmin.thead.goodsName": "GoodsName",
  "gemGoodsAdmin.thead.goodsImg": "GoodsImg",
  "gemGoodsAdmin.thead.gem_goods_type": "GemGoodsType",
  "gemGoodsAdmin.thead.stocks": "Stocks",
  "gemGoodsAdmin.thead.activeState": "ActiveState",
  "gemGoodsAdmin.thead.createdAt": "CreatedAt",
  "gemGoodsAdmin.thead.updatedAt": "UpdatedAt",

  "gemGoodsAdmin.add": "Add",
  "gemGoodsAdmin.edit": "Edit",
  "gemGoodsAdmin.details": "Details",
  "gemGoodsAdmin.delete": "Delete",

  "gemGoodsAdmin.thead.action": "Action",
};
